import React from "react";
// @material-ui/core components
import FormLabel from "@material-ui/core/FormLabel";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";

// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Select from "components/Select/Select";
import { chainOptions } from "../../const";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { Controller, useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { discordTokenService } from "services/discordTokenService";

const useStyles = makeStyles(styles);

export default function DiscordTokenCreate() {
  const {
    register: chain,
    handleSubmit,
    setValue,
    control,
  } = useForm({
    defaultValues: {
      chainId: "25",
    },
  });
  const { id } = useParams();
  const history = useHistory();

  async function create(payload) {
    try {
      await discordTokenService.create(payload);
      toast.success("Created success");
      window.setTimeout(() => history.push("/admin/discord-token/"), 500);
    } catch (e) {
      toast.error(e?.response?.data?.message[0]);
      console.log(e);
    }
  }

  async function update(payload) {
    try {
      await discordTokenService.update(id, payload);
      toast.success("Updated success");
      window.setTimeout(() => history.push("/admin/discord-token/"), 500);
    } catch (e) {
      toast.error(e?.response?.data?.message[0] || "Cannot update");
      console.log(e);
    }
  }

  async function onSubmit(form) {
    if (id) {
      update(form);
    } else {
      create(form);
    }
  }

  async function fetchData() {
    try {
      const { data } = await discordTokenService.view(id);

      const fields = ["name", "address", "chainId", "discordIcon"];
      fields.forEach((field) => setValue(field, data[field]));
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Contacts />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{!id ? "Add token" : "Edit token"}</h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Discord Icon</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...chain("discordIcon"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Name</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...chain("name"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Chain</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <Controller
                        control={control}
                        name="chainId"
                        render={({ field: { value, onChange } }) => (
                          <Select
                            name="chainId"
                            label=" "
                            onChange={onChange}
                            value={value ?? "25"}
                            options={chainOptions()}
                          />
                        )}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Address</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...chain("address"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={9}>
                      <Button onClick={() => history.goBack()}>Cancel</Button>
                      <Button color="rose" type="submit">
                        Submit
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  <GridContainer justify="flex-end"></GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}></GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
